import React from "react"

export default function Interests(){
    return (
        <div className="interests">
            <h3>Interests</h3>
            <p>Tech fanatic. Equestrian. Reader. Nature enthusiast. Life long learner.</p>
        </div>
    )
}